import {
  type AlbumTypeEnumEnum,
  type TagContentTypeEnumEnum,
  type TrackTypeEnumEnum,
  type TrackUploadStatusEnum,
} from '@/shared/api'
import { type PresetColorType } from 'antd/es/_util/colors'

export const TrackUploadStatus = {
  Uploaded: 0 as TrackUploadStatusEnum,
  Uploading: 1 as TrackUploadStatusEnum,
  DeletionPending: 2 as TrackUploadStatusEnum,
} as const

export const TrackTypeEnum = {
  Music: 1,
  Podcast: 2,
  Sermon: 3,
  AudioBook: 4,
  Jingle: 5,
} as const satisfies Record<string, TrackTypeEnumEnum>

export const TrackTypeAlbumTypeMatchEnum: Partial<
  Record<TrackTypeEnum, AlbumTypeEnumEnum>
> = {
  [TrackTypeEnum.Music]: 1,
  [TrackTypeEnum.Podcast]: 2,
  [TrackTypeEnum.AudioBook]: 3,
  [TrackTypeEnum.Sermon]: 4,
}

export const TrackTypeTagContentTypeMatchEnum: Partial<
  Record<TrackTypeEnum, TagContentTypeEnumEnum>
> = {
  [TrackTypeEnum.Music]: 1,
  [TrackTypeEnum.Podcast]: 2,
  [TrackTypeEnum.AudioBook]: 3,
}

export const trackTypeUrlParamsMap: Record<string, TrackTypeEnum | undefined> =
  {
    music: TrackTypeEnum.Music,
    podcast: TrackTypeEnum.Podcast,
    sermon: TrackTypeEnum.Sermon,
    audiobook: TrackTypeEnum.AudioBook,
  }

export const getTrackTypeKeyByValue = (value: TrackTypeEnum): string => {
  return (
    Object.entries(trackTypeUrlParamsMap).find(
      ([_, val]) => val === value,
    )?.[0] ?? ''
  )
}

export type TrackTypeEnum = (typeof TrackTypeEnum)[keyof typeof TrackTypeEnum]

export const trackTypeArray = Object.values(TrackTypeEnum)

export type TrackTypeString =
  | 'Музыка'
  | 'Подкаст'
  | 'Проповедь'
  | 'Аудиокнига'
  | 'Джингл'
  | 'Неизвестный тип'

const trackTypeStringsMap: Record<TrackTypeEnum, TrackTypeString> = {
  [TrackTypeEnum.Music]: 'Музыка',
  [TrackTypeEnum.Podcast]: 'Подкаст',
  [TrackTypeEnum.Sermon]: 'Проповедь',
  [TrackTypeEnum.AudioBook]: 'Аудиокнига',
  [TrackTypeEnum.Jingle]: 'Джингл',
}

export const getTrackTypeString = (type: number): TrackTypeString => {
  return trackTypeStringsMap[type as TrackTypeEnum] ?? 'Неизвестный тип'
}

export const getTrackTypeColor = (type: TrackTypeEnum): PresetColorType => {
  switch (type) {
    case TrackTypeEnum.Music:
      return 'magenta'
    case TrackTypeEnum.Podcast:
      return 'geekblue'
    case TrackTypeEnum.Sermon:
      return 'orange'
    case TrackTypeEnum.AudioBook:
      return 'blue'
    case TrackTypeEnum.Jingle:
      return 'purple'
    default:
      return 'cyan'
  }
}
